import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CreateEmployee, Employee, PaginatedResponse } from '@shared/models';
import { Observable } from 'rxjs';
import { ToHttpHeadersService } from '../utils';
import { ToastType } from '@shared/enums';
import { MESSAGES } from '@shared/constants';

@Injectable({
	providedIn: 'root'
})
export class EmployeeService {
	url = '/api/v1/records/employee';
	recruitmentUrl = 'api/v1/recruitment'
	http = inject(HttpClient);
	toHttpHeaders = inject(ToHttpHeadersService);

	list(filters?: any): Observable<PaginatedResponse<Employee>> {
		let params = new HttpParams();

		if (filters) {
			Object.keys(filters).forEach((key) => {
				const value = filters[key as keyof typeof filters];
				if (value !== null && value !== undefined) {
					params = params.set(key, value.toString());
				}
			});
		}

		return this.http.get<PaginatedResponse<Employee>>(this.url, { params });
	}

	listSupervisors(filters?: any): Observable<PaginatedResponse<Employee>> {
		let params = new HttpParams();

		if (filters) {
			Object.keys(filters).forEach((key) => {
				const value = filters[key as keyof typeof filters];
				if (value !== null && value !== undefined) {
					params = params.set(key, value.toString());
				}
			});
		}

		return this.http.get<PaginatedResponse<Employee>>(`${this.url}/supervisors`, { params });
	}

	createEmployee(data: CreateEmployee): Observable<Employee> {
		return this.http.post<Employee>(
			`${this.url}`,
			data,
			this.toHttpHeaders.transform(
				ToastType.SUCCESS,
				MESSAGES.SUCCESS_CREATE.replace('{$1}', 'Employee')
			)
		);
	}

	updateEmployee(data: CreateEmployee): Observable<Employee> {
		return this.http.put<Employee>(
			`${this.url}`,
			data,
			this.toHttpHeaders.transform(
				ToastType.SUCCESS,
				MESSAGES.SUCCESS_UPDATE.replace('{$1}', 'Employee')
			)
		);
	}

	getById(id: number | string): Observable<any> {
		return this.http.get(`${this.url}/${id}`);
	}

	getCurrentSalaryByEmployeeId(empId: number): Observable<any> {
		return this.http.get(`/api/v1/records/personnel-action-notice/salary/${empId}`);
	}

	formatEmployeeName(name: any, reverse = false): string {
		if (!name) return '';
		const { givenName, middleName, familyName, suffix } = name;

		if (reverse) {
			return [
			familyName,
			',',
			givenName,
			middleName ? middleName[0] + '.' : '',
			suffix ? ', ' + suffix : ''
			]
			.filter(Boolean)
			.join(' ')
			.replace(/\s+/g, ' ')
			.trim();
		}

		return [
			givenName,
			middleName ? middleName[0] + '.' : '',
			familyName,
			suffix ? ', ' + suffix : ''
		]
			.filter(Boolean)
			.join(' ')
			.replace(/\s+/g, ' ')
			.trim();
	}

	generatePDF(jobAppId: number, data: any): Observable<Blob> {
		return this.http.post(
			`${this.recruitmentUrl}/job-applicant/personnel-data-form/${jobAppId}`,
			data,
			{
			...this.toHttpHeaders.transform(
				ToastType.SUCCESS,
				MESSAGES.SUCCESS_GENERIC.replace('{$1}', 'generated').replace(`{$2}`, `Personnel Data Form`)
			),
			responseType: 'blob'
			}
		) as Observable<Blob>;
	}
}
